import React from 'react';
import styled from 'styled-components';
import ProductCategoriesSection from '../components/ProductCategoriesSection';

const PageContainer = styled.div`
  padding-top: var(--header-h); /* Header yüksekliği kadar boşluk */
  min-height: 100vh;
`;

const ProductsPage: React.FC = () => {
  return (
    <PageContainer>
      <ProductCategoriesSection />
    </PageContainer>
  );
};

export default ProductsPage;
